export default class BrokenLinkError extends Error {}
